import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import style from './style.m.less'

const FooterInfo: FC = () => {
    const { t } = useTranslation()

    return (
        <>
            <div className={style.footerInfo}>
                <div className={style.infoText}>{t('footer.address')}</div>
                <div className={style.phoneBlock}>
                    <div>+7 (495) 740-30-27</div>
                </div>
                <div>
                    <div className={style.footerInfoBlock}>
                        <div>
                            <div>{t('footer.support')}</div>
                            <div>
                                <a href="mailto:help@g-e-t.ru">help@g-e-t.ru</a>
                            </div>

                            <div className={style.footerInfoBlockItem}>
                                {t('footer.application')}
                            </div>
                            <div>
                                <a href="mailto:mail@g-e-t.ru">mail@g-e-t.ru</a>
                            </div>

                            <div className={style.footerInfoBlockItem}>{t('feedback.text')}</div>
                            <div>
                                <a href="/feedback-form">{t('feedback.title')}</a>
                            </div>

                            <div className={style.footerInfoBlockItem}>
                                <a href="/documents/cookiePolicy.pdf" target="_blank">
                                    {t('footer.cookies')}
                                </a>
                            </div>

                            <div className={style.footerInfoBlockItem}>
                                <a href="/documents/privacyPolicy.pdf" target="_blank">
                                    {t('footer.privacyPolicy')}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default FooterInfo
